import { InjectionToken } from '@angular/core';

export const API_ROOT_TOKEN: InjectionToken<string> = new InjectionToken<string>('apiRoot');
export const IS_LOCALHOST_TOKEN: InjectionToken<boolean> = new InjectionToken<boolean>('isLocalhost');
export const ERC_LOGIN_URL_TOKEN: InjectionToken<string> = new InjectionToken<string>('ercLoginUrl');
